// extracted by mini-css-extract-plugin
export default {"link-button":"LinkButton_link-button__ZXkjx"};